module.exports = "<label class=\"drop-place\"> <i>" + require('icons/cloud-upload.svg') + "</i> <span>Drop files to upload or <span class=\"link\">browse</span></span> <input type=\"file\" multiple=\"multiple\" style=\"display:none\" (change)=\"upload($event.target.files)\"> </label> <p *ngFor=\"let error of errors\" class=\"form__error\">{{ error }}</p> <app-upload-modal (onUploaded)=\"attachments.emit($event)\"></app-upload-modal> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/attachments/drop-area.component.html
// module id = ./src/app/shared/components/attachments/drop-area.component.html
// module chunks = 21